export const GoogleMapApiConfig = 'AIzaSyCwfRlzXx-5iSKjYh-fs7nKWkJHicWXRNw';